import React from 'react';
import type { DropdownProps } from '../types';

/**
 * Dropdown component for displaying floating content
 * 
 * This component renders a positioned dropdown container that can be used for
 * displaying various content like menus, options lists, or other floating UI elements.
 * It supports absolute positioning and optional width configuration.
 * 
 * @example
 * <Dropdown
 *   isOpen={true}
 *   position={{ top: 100, left: 200 }}
 *   width={300}
 *   onScroll={handleScroll}
 * >
 *   <div>Dropdown content</div>
 * </Dropdown>
 */
export const Dropdown: React.FC<DropdownProps> = ({
  isOpen,
  position,
  width,
  onScroll,
  children
}) => {
  // Early return if dropdown should not be visible
  if (!isOpen) return null;

  return (
    <div
      onScroll={onScroll}
      style={{ top: `${position.top}px`, left: `${position.left}px`, width: width }}
      className="fixed max-h-72 overflow-y-auto bg-gray-800 text-gray-200 dark:bg-gray-900 dark:text-gray-100 border border-gray-700 rounded shadow-sm z-50"
    >
      {children}
    </div>
  );
}; 